/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsGovernanceSystem extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsGovernanceSystem");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsGovernanceSystem.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsGovernanceSystem>): RecommendationForFinopsGovernanceSystem {
        let obj = Object.assign(new RecommendationForFinopsGovernanceSystem(), model);
        RecommendationForFinopsGovernanceSystem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsGovernanceSystem>): RecommendationForFinopsGovernanceSystem {
        if (!model) return null;
        return RecommendationForFinopsGovernanceSystem.newInstance(<RecommendationForFinopsGovernanceSystem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsGovernanceSystem) {
        if (!obj) return;

        models.RecommendationForFinopsGovernanceSystem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsGovernanceSystem): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsGovernanceSystem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
